// extracted by mini-css-extract-plugin
module.exports = {"loading":"Loading_loading__Qj_xJ","active":"Loading_active__wqP_K","dot":"Loading_dot__kFQse","whiteDots":"Loading_whiteDots__Pojso"};